<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-notice">
            <div class="notice-header">
              <h3 class="title">
                <div class="item">
                  {{ $t('cs002.pageTitle') }}
                </div>
              </h3>
            </div>
            <!-- 대상 N개 골프클럽(Class) : objectFew -->
            <!-- 유형 버전(Class) : typeVersion / 유형 이벤트(Class) : typeEvent / 유형 확인중(Class) : typeChecking -->
            <div :class="(noticeType==='Version') ? 'notice-view objectFew typeVersion' : (noticeType==='Event') ? 'notice-view objectFew typeEvent' : (noticeType==='Checking') ? 'notice-view objectFew typeChecking' : 'notice-view objectFew'">
              <div class="header">
                <div class="type">
                  <div class="item">
                    {{ (noticeType=='Version') ? $t('cs002.version') : (noticeType=='Event') ? $t('cs002.event') : (noticeType=='Checking') ? $t('cs002.checking') : noticeType }}
                  </div>
                </div>
                <div class="title">
                  {{title}}
                </div>
                <div class="writer">
                  {{ $t('cs002.operator') }}: {{((findAccountId(isrtId) !== undefined) && (findAccountId(isrtId) !== null) && (findAccountId(isrtId) !== '')) ? findAccountId(isrtId) : (userInfo.userName === '') ? $t('cs002.notEntered') : userInfo.userName  }}
                </div>
                <div class="date">
                  {{(updtDt===undefined) ? $t('cs002.dateNotEntered') :(updtDt==null) ? $t('cs002.dateNotEntered') : (updtDt=='') ? $t('cs002.dateNotEntered') : updtDt.substring(0,10)}}
                </div>
              </div>
              <div class="body">
                <div class="info object">
                  <!-- 툴팁 활성 : tooltipActive -->
                  <div class="caption object" :class="tooltipActive ? 'tooltipActive' : ''">
                    <div class="title">
                      {{ $t('cs002.target') }}
                    </div>
                    <div class="content" @click="openTooltip" ref="tooltip">
                      {{ computedClubTarget }}
                    </div>
                    <div class="tooltip">
                      {{ ellipsisClubString }}
                    </div>
                  </div>
                  <div class="caption hits">
                    <div class="title">
                      {{ $t('cs002.views') }}
                    </div>
                    <div class="content">
                      {{viewCnt}}
                    </div>
                  </div>
                </div>
                <div class="view">
                  {{content}}
                </div>
                <div class="info status">
                  <div class="caption status">
                    <div class="title">
                      {{ $t('cs002.status') }}
                    </div>
                    <div class="content">
                      {{findStatusName(status)}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="notice-button">
              <button class="list" @click="moveMenu('/CS001')">
                {{ $t('common.list') }}
              </button>
              <button class="edit" @click="moveMenu('/CS004?notice_id=' + noticeId)">
                {{ $t('cs002.editButton') }}
              </button>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <!-- 확인만(Class) : typeConfirm -->
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    {{ $t('cs002.replyAlert1') }}<br />
                    {{ $t('cs002.replyAlert2') }}<br />
                    {{ $t('cs002.replyAlert3') }}
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <button class="confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {aplManagerService, clubInfoService, userService} from '../../router'

export default {
  name: 'CS002',
  data () {
    return {
      orderTarget: '',
      orderValue: '',
      paramStatus: '',
      paramAuthority: '',
      search_word: '',
      accountInfoList: [],
      isrtId: '',
      clubInfoList: [],
      clubTargets: [],
      targetAll: false,
      loading: true,
      noticeId: '',
      noticeType: '',
      status: '',
      title: '',
      content: '',
      viewCnt: '',
      updtDt: '',
      noticeData: {
        notice: {
          notice_id: null,
          notice_type: '',
          status: '',
          title: '',
          content: '',
          view_cnt: null,
          isrt_id: null,
          isrt_dt: '',
          updt_id: null,
          updt_dt: ''
        }
      },
      totalNotice: []
    }
  },
  created: function () {
  },
  mounted: function () {
    let noticeId = this.$route.query.notice_id
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.userInfo.userRole === 'ClubManager') {
        this.setData(noticeId)
      } else {
        Promise.all([aplManagerService.getSummaryManagementUserListView(this.orderTarget, this.orderValue, this.paramStatus, this.paramAuthority, this.search_word)])
          .then(response => {
            this.accountInfoList = response[0].data.accountList
            this.setData(noticeId)
          }).catch(error => {
            console.log('getCustomerNoticeTargetsNoticeId.err.===>', error)
          })
      }
    })
  },
  methods: {
    findAccountId: function (accountId) {
      if (this.accountInfoList.find(it => it.account_id === accountId) !== undefined) {
        return this.accountInfoList.find(it => it.account_id === accountId).user_name
      } else {
        return ''
      }
    },
    findClubName: function (ccode) {
      if (this.clubInfoList.find(it => it.ccode === ccode) !== undefined) {
        return this.clubInfoList.find(it => it.ccode === ccode).club_name
      } else {
        return ''
      }
    },
    moveMenu: function (path) {
      this.$router.push(path)
    },
    findStatusName: function (status) {
      if (this.statusCodeList.find(it => it.statusCode === status) !== undefined) {
        return this.statusCodeList.find(it => it.statusCode === status).statusName
      } else {
        return ''
      }
    },
    setData: function (noticeId) {
      aplManagerService.getCustomerNoticeNoticeId(noticeId).then(response => {
        if (response.data.notice === undefined) {
          this.moveMenu('/CS001')
          return false
        }
        this.noticeData.notice = response.data
        this.isrtId = this.noticeData.notice.notice.isrt_id
        this.noticeId = this.noticeData.notice.notice.notice_id
        this.noticeType = this.noticeData.notice.notice.notice_type
        this.status = this.noticeData.notice.notice.status
        this.title = this.noticeData.notice.notice.title
        this.content = this.noticeData.notice.notice.content
        this.viewCnt = this.noticeData.notice.notice.view_cnt
        this.updtDt = this.noticeData.notice.notice.isrt_dt
        aplManagerService.getCustomerNoticeTargetsNoticeId(noticeId).then(response => {
          // TODO : findClubName 하는데 너무 느린듯 ccode말고 clubname 바로 받아오기
          clubInfoService.getClubInfoList().then(_response => {
            this.clubInfoList = _response.data.clubInfoList
            if (response.data.targetAll === 1) {
              this.targetAll = true
              this.clubTargets = this.clubInfoList
            } else {
              this.clubTargets = response.data.noticeTarget.filter(club => club.ccode !== '')
            }
            if (this.clubTargets.length === 0 || (this.clubTargets.length === 1 && !this.clubTargets[0])) {
              this.clubTargets = []
            }
            this.loading = false
          }).catch(error => {
            console.log('getClubInfoListByStatusActive.err.===>', error)
          })
        }).catch(error => {
          console.log('getCustomerNoticeTargetsNoticeId.err.===>', error)
        })
      }).catch(error => {
        console.log('getCustomerNoticeNoticeId.err.===>', error)
      })
    }
  },
  computed: {
    statusCodeList: function () {
      return [
        {
          statusCode: 'ACTIVE',
          statusName: this.$t('cs002.active')
        },
        {
          statusCode: 'PASSIVE',
          statusName: this.$t('cs002.inactive')
        }
      ]
    },
    computedClubTarget: function () {
      if (!this.clubTargets.length && this.loading) return ''
      if (!this.clubTargets.length) return this.$t('cs002.notEntered')
      if (this.clubTargets.length === 1) {
        let target = this.clubInfoList.find(el => el.ccode === this.clubTargets[0].ccode)
        return target ? target.club_name : this.$t('cs002.golfClubCount', { n: 1 })
      }
      if (this.targetAll) return this.$t('common.all')
      return this.$t('cs002.golfClubCount', { n: this.clubTargets.length })
    },
    ellipsisClubString: function () {
      let clubString = this.clubTargets.slice(0, 10).map(el => this.findClubName(el.ccode)).join(',')
      if (this.clubTargets.length > 10) clubString += '...'
      return clubString
    }
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cs/CS002.vue